import { cn } from '@quadralize/utils'
import { Eye, EyeClosed } from '@solar-icons/react'
import * as React from 'react'
import { LabelWrapper } from '../label/label'
import { Input, type InputProps } from './input'

const PasswordInput = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, label, labelRight, helperText, id, required, error, enableAutofill, ...props },
    ref,
  ) => {
    const [showPassword, setShowPassword] = React.useState(false)
    const generatedId = React.useId()
    const inputId = id || generatedId

    return (
      <LabelWrapper
        label={label}
        id={inputId}
        required={required}
        error={error}
        labelRight={labelRight}
        helperText={helperText}
      >
        <div className="relative">
          <Input
            id={inputId}
            type={showPassword ? 'text' : 'password'}
            className={cn(
              'pr-9',
              !showPassword &&
                'font-mono tracking-tighter placeholder:tracking-tight placeholder:font-sans',
              className,
            )}
            ref={ref}
            required={required}
            enableAutofill={enableAutofill}
            {...props}
            label={undefined}
          />
          <button
            type="button"
            className="absolute right-3 top-1/2 -translate-y-1/2 text-text-tertiary hover:text-text-primary focus:outline-none transition-colors"
            onClick={() => setShowPassword((prev) => !prev)}
            tabIndex={-1}
          >
            {showPassword ? <Eye className="h-4 w-4" /> : <EyeClosed className="h-4 w-4" />}
          </button>
        </div>
      </LabelWrapper>
    )
  },
)
PasswordInput.displayName = 'PasswordInput'

export { PasswordInput }
